function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'2a0a8a57c6e27e2fd2874de0a30070bc': 'rgb(169, 168, 173)','7b09df2c4f77fe14251d020a5fe7c3fc': 'rgb(94, 117, 143)','e9052759d3b64201aca90f6cb831ecf9': 'rgb(211, 123, 93)','8591294e5616ecd5261bf3b6a6eacf2c': 'rgb(34, 33, 36)','0d14d8e8e1249432f0e18930c4486698': 'rgb(70, 46, 40)','cabdb1014252d39ac018f447e7d5fbc2': 'rgb(213, 192, 161)','bda968b677ab61ef27d29a78e7408e8b': 'rgb(53, 57, 53)','614a657a5a8a2267b807bb8eb72941a2': 'rgb(153, 0, 0)',};

    this.images = {'c9ab83f09006371cb3f745a03b1f8c64': 'url("//www.pontofootwear.com/cdn/shop/files/citrine_68x.png?v=6413005436802742723")','664a6ce41022b4d79f926cf89eed8ccd': 'url("//www.pontofootwear.com/cdn/shop/files/lagoon_68x.png?v=2095431359764652204")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
